module.exports = __webpack_public_path__ + "static/interval-logo-b8d24ac8cebfabc784de95a8a24ac5e9.jpg";